import { useRef } from "react";
import { useStarfield } from "../hooks/useStarfield";

export function Starfield() {
  const ref = useRef<HTMLCanvasElement | null>(null);
  useStarfield(ref);
  return <canvas id="starfield" className="hero-canvas" ref={ref}></canvas>;
}
